import React from 'react';
import { Link } from "react-router-dom";
import Button from 'material-ui/Button';
//import { CircularProgress } from 'material-ui/Progress';
import ErrorIcon from 'material-ui-icons/ErrorOutline';
import Wait from './Wait';

export default ({label, headerLink, submitButton, children, errorMessage, waiting, formWidth='small'}) => (
	<div
		className={`ShortForm ${!!waiting && 'loading'}`}
		style={{
			margin: {small:'50px auto 50px auto', medium:'0px auto 50px auto', large:'0px 20px 50px 20px'}[formWidth],
			width:{small:'600px', medium:'900px', large:'auto'}[formWidth],
			position:'relative',

		}}
		onKeyPress={ (event) => {
			if(['TEXTAREA','SELECT'].includes(event.target.tagName)){return;}
			if(document.location.href.includes('/edit-experiment') || document.location.href.includes('/experiments/')){
				return;
			}
			if(event.key === 'Enter' && submitButton.onClick && event){
				submitButton.onClick(event);
			}
		}}
		>
		{headerLink &&
			<Link to={headerLink.to} style={{position:"absolute", right:0, top:'45px', fontSize:'13px'}}>{headerLink.label}</Link>
		}
		<h1>{label}</h1>

		{children}

		<div style={{marginTop:'20px', display:'flex', flexDirection:"row"}}>
			<div style={{flex:1, color:"var(--red)", textAlign:"right", marginRight:"20px", marginTop:"10px"}}>
				{errorMessage && <ErrorIcon style={{ width: 16, height: 16, position:'relative', top:'2px', marginRight:'3px' }} />}
				{errorMessage}
			</div>
			
			{ submitButton && 
				<Button className='submit-button' variant="raised" color="primary" onClick={submitButton.onClick}>
					{submitButton.label}
				</Button>
			}
		</div>
		{ !!waiting && <Wait />}
	</div>
)


// WEBPACK FOOTER //
// ./src/components/ShortForm.js